// extracted by mini-css-extract-plugin
export default {"mainContainer":"Misreservas_mainContainer__bv6yz","hr":"Misreservas_hr__tLddG","tableContainer":"Misreservas_tableContainer__mpv86","header":"Misreservas_header__ViznH"};